/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateLabelRequestLabelFromJSON, CreateLabelRequestLabelToJSON } from './CreateLabelRequestLabel';
export function CreateLabelRequestFromJSON(json) {
    return CreateLabelRequestFromJSONTyped(json, false);
}
export function CreateLabelRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        label: !exists(json, 'label') ? undefined : CreateLabelRequestLabelFromJSON(json['label'])
    };
}
export function CreateLabelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        label: CreateLabelRequestLabelToJSON(value.label)
    };
}
